import React, { useContext, useEffect, useState, useMemo } from "react";

import Toolbar from "Trackalyze/Toolbar";
import { useTranslation } from "react-i18next";
import Button from "Trackalyze/Button";
import { SORTKEYS } from "./sortHelper";
import Flex, { FlexItem } from "Trackalyze/Flex";
import { FilteredTracksContext } from "~/Context/FilteredTracksContext";
import List, { ListItem } from "Trackalyze/List";

const Sort = (props) => {
  const { t } = useTranslation();
  const { sortOptions, setSortOptions, filteredTracks } = useContext(
    FilteredTracksContext,
  );

  const availableSortKeys = useMemo(() => {
    if (!filteredTracks || filteredTracks.length === 0) return SORTKEYS;
    return SORTKEYS.filter((item) => {
      return filteredTracks.some((track) => {
        const val = track[item.key];
        return val !== null && val !== undefined;
      });
    });
  }, [filteredTracks]);

  const handleSorting = (
    sortBy = "stats.distance.total",
    sortOrder = "asc",
  ) => {
    setSortOptions({ sortBy: sortBy, sortOrder: sortOrder });
    setTimeout(() => {
      props.onClose();
    }, 100);
  };

  return (
    <Flex vertical className="ta-height_full">
      <FlexItem className="ta-padding_xs ta-is-overflow ta-hack_maxheight">
        {props.portrait ? (
          <Toolbar small title={t("trackManager.sortTitle")}>
            <Button
              icon
              symbol={
                sortOptions.sortOrder === "asc"
                  ? "arrow_upward"
                  : "arrow_downward"
              }
              onClick={() => {
                handleSorting(
                  sortOptions.sortBy,
                  sortOptions.sortOrder === "asc" ? "desc" : "asc",
                );
              }}
            />
          </Toolbar>
        ) : (
          <Toolbar title={t("trackManager.sortTitle")}>
            <Button
              icon
              symbol={
                sortOptions.sortOrder === "asc"
                  ? "arrow_upward"
                  : "arrow_downward"
              }
              onClick={() => {
                handleSorting(
                  sortOptions.sortBy,
                  sortOptions.sortOrder === "asc" ? "desc" : "asc",
                );
              }}
            />
          </Toolbar>
        )}
        <Flex flexitem className="ta-is-overflow" vertical spacing="1">
          <List>
            {availableSortKeys.map((item, idx) => {
              return (
                <ListItem
                  onClick={() => handleSorting(item.key, sortOptions.sortOrder)}
                  key={"sortitems_" + idx}
                  selected={sortOptions.sortBy === item.key}
                  label={t(item.label)}
                />
              );
            })}
          </List>
        </Flex>
      </FlexItem>
    </Flex>
  );
};

export default React.memo(Sort);
